import { Box } from '@mui/material';

import { RadioBoxButton } from '@/components';
import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { getDesignationYearOptions } from '../utils';
import { ExtraBold } from './ExtraBold';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalTitle } from './ModalTitle';

export const CanCpaYearForm = () => {
  const dispatch = useAppDispatch();

  const stepInputs = useAppSelector(selectOnboardingStepInputs);

  const { value: year } = stepInputs[STEP_IDS.canCpaYear];
  const designationYearOptions = getDesignationYearOptions();

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} />
      <Box sx={styles.formPrimarySection}>
        {Object.keys(designationYearOptions)
          .map(Number)
          .reverse()
          .map(current => (
            <Box key={current} sx={styles.checkboxContainer}>
              <RadioBoxButton
                label={designationYearOptions[current].toString()}
                checked={current === year}
                onChange={() =>
                  dispatch(
                    onboardingActions.updateStepInputs({
                      step: STEP_IDS.canCpaYear,
                      input: current,
                    }),
                  )
                }
              />
            </Box>
          ))}
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => {
  return (
    <ModalTitle>
      As a <ExtraBold>CPA</ExtraBold> in <ExtraBold>Canada</ExtraBold>, what
      year did you get your designation?
    </ModalTitle>
  );
};
